export interface IOpportunityTitle {
  name: string;
  address: string;
  county: string;
  township: string;
  type: string;
}

export class OpportunityTitle implements IOpportunityTitle {
  name: string;
  address: string;
  county: string;
  township: string;
  type: string;
}
